import { render, staticRenderFns } from "./WorkShiftListField.vue?vue&type=template&id=cb24cb18&scoped=true&"
import script from "./WorkShiftListField.vue?vue&type=script&lang=js&"
export * from "./WorkShiftListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb24cb18",
  null
  
)

export default component.exports